<template>
   <div class="container">
      <div class="row justify-content-center">
         <div class="col-md-5 col-lg-4 my-5">
            <div class="card bg-light bg-gradient shadow-lg rounded-4 animate__animated animate__fadeInDown">
               <div class="card-body bg-sa-card-body p-2">

                <!--Addition-->                
            <!-- Unified Alert -->
               <div v-if="showAlert" :class="['alert', `alert-${alertType}`]" role="alert">
                <i class="fa-fw fa me-2"
                   :class="alertType === 'success' ? 'fa-check' : 'fa-times'">
                </i>
                {{ alertMessage }}
              </div>
            <!--End Unified Alert -->
                <!--End Addition-->

                  <h3 class="card-title text-center mb-2">Forgot Password</h3>
                  <form id="forgotPasswordForm" autocomplete="off" @submit.prevent="forgotPasswordSubmit">
                     <div class="mb-0">
                        <label for="email" class="form-label">Email address</label>
                        <div class="input-group">
                           <span class="input-group-text d-md-flex"><i class="fa fa-envelope"></i></span>
                           <input v-model="email" @input="handleInputChange" @change="handleInputChange" type="email" class="form-control custom-tooltip-input" id="email" placeholder="Enter email"   required autocomplete="new-email">
                           <div class="custom-tooltip">Please enter your Email <span class="tooltip-arrow"></span></div>
                        </div>
                     </div>
                     <div class="d-flex justify-content-end mb-1">                        
                      
                     </div>
                     <div class="d-grid mb-0">
                        <button type="submit" class="btn btn-primary"
                                :disabled="sendingCode || cooldown > 0">
                            <i v-if="sendingCode" class="fa fa-cog fa-spin me-1"></i>
                            {{ buttonLabel }}
                        </button>
                     </div>
                  </form>
                     <p class="text-center text-muted mt-3 small bg-sa-login-reg-text">                    
                        <router-link to="/register/">
                          <a href="#" class="text-decoration-none btn btn-primary d-grid mb-0">Sign up</a>
                        </router-link>
                     </p>
                     <p class="text-center text-muted mt-3 small bg-sa-login-reg-text">
                                               
                        <router-link to="/login/">
                         <a href="#" class="text-decoration-none small btn btn-primary d-grid mb-0">Login</a>
                      </router-link>
                     </p>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>
<script>
   import { computed } from 'vue';
   import axios from 'axios'
   import emitter from '../../../main.js'
   //var Emitter = require('tiny-emitter');
   //var emitter = new Emitter();
   
   	export default {
   		components: {
   		},
   		data(){
   			return {
   					email: "", 
                  showAlert: false,
                  alertType: '', // 'success' or 'danger'
                  alertMessage: '',
                  progressMessage: 'Sending reset email link. Please wait',
                  button_text: 'Send Reset Link',
                  sendingCode: false,
                  sentOnce: false,
                  cooldown: 0,          // seconds left before Resend works
                  cooldownTimer: null,
   			}
   		},
   		created() {
   		},
         beforeUnmount() {
            clearInterval(this.cooldownTimer);
         },
         computed: {
            buttonLabel() {
               if (this.sendingCode) return 'Sending...';
               if (this.cooldown > 0) {
                  const s = String(this.cooldown % 60).padStart(2, '0');
                  return `Resend in ${Math.floor(this.cooldown / 60)}:${s}`;
               }
               return this.sentOnce ? 'Resend Link' : this.button_text;
            },
         },
   		methods: {
            // Same wait as the server ($resendAfterSeconds in handleSendResetEmail)
            startCooldown(seconds = 60) {
               clearInterval(this.cooldownTimer);
               this.cooldown = seconds;
               this.cooldownTimer = setInterval(() => {
                  this.cooldown--;
                  if (this.cooldown <= 0) {
                     clearInterval(this.cooldownTimer);
                  }
               }, 1000);
            },
   			handleInputChange(event) {
         // Call the validation function for the specific input field that triggered the event
         this.$validateField(event.target);
         //formValidations(event.target);
       },
   			async forgotPasswordSubmit() {
    if (!this.$validateForm('#forgotPasswordForm')) {
        return;
    }
    if (this.sendingCode || this.cooldown > 0) {
        return;
    }
    this.sendingCode = true;

    try {
        const formData = new FormData();
        formData.append('action', 'forgotPassword');
        formData.append('email', this.email);

        const response = await axios.post(
            this.$baseUrl + '/auth/api_auth.php',
            formData
        );

        if (response.data.status === 'success') {

            // Show success alert immediately.
            this.showAlert = true;
            this.alertType = 'success';
            this.alertMessage = response.data.message;
            this.sentOnce = true;
            this.startCooldown(60);

            // Initiate email sending separately.
            const emailData = new FormData();
            emailData.append('action', 'sendResetEmail');
            emailData.append('email', this.email);

            axios.post(
                this.$baseUrl + '/auth/api_auth.php',
                emailData
            ).catch(error => {
                console.error(
                    'Password reset email sending failed:',
                    error.response?.data || error.message
                );
            });

        } else {
            this.showAlert = true;
            this.alertType = 'danger';
            this.alertMessage = response.data.message;
        }

    } catch (error) {
        console.error(error);

        this.showAlert = true;
        this.alertType = 'danger';
        this.alertMessage =
            'Unable to process your request. Please try again.';
    } finally {
        this.sendingCode = false;
    }
}



   		}
   	};
</script>